import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import EducationMaterialList from "./EducationMaterialList";
import EducationMaterialImageForm from "./EducationMaterialImageForm";
import EducationMaterialForm from "./EducationMaterialForm";
import EducationMaterialPreview from "./EducationMaterialPreview";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css'

class EducationMaterials extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };

        this.handleAddEducationMaterial = this.handleAddEducationMaterial.bind(this);
        this.handleEditEducationMaterial = this.handleEditEducationMaterial.bind(this);
        this.handleRemoveEducationMaterial = this.handleRemoveEducationMaterial.bind(this);
        this.handleAddEducationMaterialImage = this.handleAddEducationMaterialImage.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
    }

    handleAddEducationMaterial(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };

        let questions = [];
        values.questions.forEach((question) => {
                questions.push(axios.post(this.props.api.questions, question, config))
            }
        );

        axios.all(questions).then((responses) => {
            let questionIds = [];
            let answersRequests = [];
            responses.forEach((response, questionIndex) => {
                questionIds.push(response.data.id);
                // odpovědi k otázce
                values.questions[questionIndex].answers.forEach((answer, answerIndex) => {
                   answersRequests.push(axios.post(this.props.api.answers, {
                       ...answer,
                       order: answerIndex,
                       question: response.data.id
                   }, config));
                });
            });
            axios.all(answersRequests).then(() => {
                axios.post(this.props.api.educationMaterials, {
                    name: values.name,
                    shortText: values.shortText,
                    materialText: values.materialText,
                    questions: questionIds
                }, config).then((response) => {
                    this.props.addNotification('success', response.status, 'Vzdělávací materiál ' + response.data.name + ' byl vytvořen.');
                    this.props.history.push('/educationMaterials');
                }).catch((error) => {
                    this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Vzdělávací materiál se nepodařilo vytvořit!');
                    this.props.history.push('/educationMaterials');
                    console.log("Axios error: ", error);
                });
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se přidat jednu z odpovědí!');
                this.props.history.push('/educationMaterials');
                console.log("Axios error: ", error);
            });
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se přidat jednu z otázek!');
            this.props.history.push('/educationMaterials');
            console.log("Axios error: ", error);
        });
    }

    handleEditEducationMaterial(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };

        let answersToDelete = values.answersToDelete;
        let deleteRequests = [];

        // otázky ke smazání
        if (answersToDelete) {
            answersToDelete.forEach((answer) => {
                deleteRequests.push(axios.delete(this.props.api.answers + "/" + answer._id, config))
            });
        }

        // smazání odpovědí
        axios.all(deleteRequests).then(() => {
            // rozdělení, které otázky přidat a které upravit
            let questions = values.questions;
            let addAnswers = [];
            let editAnswers = [];
            let editRequests = [];
            questions.forEach((question) => {
                let answers = question.answers.map((answer, index) => {
                   return ({
                       ...answer,
                       order: index + 1,
                       question: question.id
                   });
                });
                answers.filter((answer) => answer._id).forEach((answer) => {
                    editAnswers.push(answer);
                });
                answers.filter((answer) => !answer._id).forEach((answer) => {
                    addAnswers.push(answer);
                });
            });

            // úprava odpovědí
            editAnswers.forEach((answer) => {
                editRequests.push(axios.put(this.props.api.answers + "/" + answer._id, answer, config));
            });
            axios.all(editRequests).then(() => {
                // přidání odpovědí
                let addRequests = [];
                addAnswers.forEach((answer) => {
                    addRequests.push(axios.post(this.props.api.answers, answer, config));
                });
                axios.all(addRequests).then(() => {
                    let questions = [];
                    values.questions.forEach((question) => {
                            questions.push(axios.put(this.props.api.questions + "/" + question._id, question, config))
                        }
                    );
                    axios.all(questions).then(() => {
                        // úprava vzdělávacího materiálu
                        axios.put(this.props.api.educationMaterials + "/" + values.id,{
                            name: values.name,
                            materialText: values.materialText,
                            shortText: values.shortText
                        }, config).then((response) => {
                            this.props.addNotification('success', response.status, 'Vzdělávací materiál ' + response.data.name + ' byl upraven.');
                            this.props.history.push('/educationMaterials');
                        }).catch((error) => {
                            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Vzdělávací materiál se nepodařilo upravit!');
                            this.props.history.push('/educationMaterials');
                            console.log("Axios error: ", error);
                        });
                    }).catch((error) => {
                        this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se upravit jednu z otázek!');
                        this.props.history.push('/educationMaterials');
                        console.log("Axios error: ", error);
                    })
                }).catch((error) => {
                    this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se přidat jednu z odpovědí!');
                    this.props.history.push('/educationMaterials');
                    console.log("Axios error: ", error);
                });
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se upravit jednu z odpovědí!');
                this.props.history.push('/educationMaterials');
                console.log("Axios error: ", error);
            });
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se odstranit jednu z odpovědí!');
            this.props.history.push('/educationMaterials');
            console.log("Axios error: ", error);
        });
    }

    handleAddEducationMaterialImage(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.put(this.props.api.educationMaterials + "/" + values.id, {
            ...values
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Obrázek vzdělávacího materiálu ' + response.data.name + ' byl upraven!');
            this.props.history.push('/educationMaterials');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Obrázek vzdělávacího materiálu se nepodařilo upravit!');
            this.props.history.push('/educationMaterials');
            console.log("Axios error: ", error);
        })
    }

    handleRemoveEducationMaterial(educationMaterial) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        // get and delete questions, which are not used
        let questions = educationMaterial.questions.filter((question) => !question.used);
        let deleteQuestionRequests = [];
        questions.forEach((question) => {
            // get and delete answers
            axios.get(this.props.api.questionAnswers + question.id, config).then((response) => {
                let deleteAnswerRequests = [];
                response.data.forEach((answer) => {
                    deleteAnswerRequests.push(axios.delete(this.props.api.answers + "/" + answer.id, config));
                });
                axios.all(deleteAnswerRequests).then(() => {
                    deleteQuestionRequests.push(axios.delete(this.props.api.questions + "/" + question.id, config));
                }).catch((error) => {
                    this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se odstranit jednu z odpovědí!');
                    console.log("Axios error: ", error);
                });
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se získat odpovědi k jedné z otázek!');
                console.error('Axios error: ', error);
            });
        });

        axios.all(deleteQuestionRequests).then(() => {
            // delete education material
            axios.delete(this.props.api.educationMaterials + "/" + educationMaterial.id, config)
            .then((response) => {
                this.props.addNotification('success', response.status, 'Vzdělávací materiál ' + educationMaterial.name + ' byl odstraněn');
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Vzdělávací materiál ' + educationMaterial.name + ' se nepodařilo odstranit!');
                console.log("Axios error: ", error);
            });
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se odstranit jednu z otázek!');
            console.log("Axios error: ", error);
        });
    }

    handleChangeEnabled(educationMaterial){
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };

        const enabled = !educationMaterial.enabled;

        axios.put(this.props.api.educationMaterials + "/" + educationMaterial.id, {
            enabled
        }, config).then((response) => {
            if (!educationMaterial.enabled) {
                this.props.addNotification('success', response.status, 'Vzdělávací materiál ' + educationMaterial.name + ' byl povolen.');
            } else {
                this.props.addNotification('success', response.status, 'Vzdělávací materiál ' + educationMaterial.name + ' byl zakázán.');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Vzdělávací materiál se nepodařilo '+(enabled ? 'povolit' :  'zakázat')+'!');
            console.log("Axios error: ", error);
        })
    }

    render() {
        return (
            <div id="page-educationMaterials" className="right-col" role="main">
                <div className="page-title">
                    <h3>Vzdělávací materiály</h3>
                </div>
                <Switch>
                    <Route exact path="/educationMaterials" component={() =>
                        <EducationMaterialList
                            {...this.props}
                            handleChangeEnabled={this.handleChangeEnabled}
                            handleRemoveEducationMaterial={this.handleRemoveEducationMaterial}
                        />
                    }
                    />
                    <Route path="/educationMaterials/preview/:id" component={() =>
                        <EducationMaterialPreview
                            {...this.props}
                        />
                    }
                    />
                    <Route path="/educationMaterials/add" component={() =>
                        <EducationMaterialForm
                            {...this.props}
                            title="Formulář pro přidání vzdělávacího materiálu"
                            button="Přidat"
                            action={this.handleAddEducationMaterial}
                        />
                    }
                    />
                    <Route path="/educationMaterials/edit/:id" component={() =>
                        <EducationMaterialForm
                            {...this.props}
                            title="Formulář pro úpravu vzdělávacího materiálu"
                            button="Upravit"
                            action={this.handleEditEducationMaterial}
                        />
                    }
                    />
                    <Route path="/educationMaterials/image/:id" component={() =>
                        <EducationMaterialImageForm
                            {...this.props}
                            title="Přidání obrázku ke vzdělávacímu materiálu"
                            button="Uložit"
                            size={this.state.size}
                            action={this.handleAddEducationMaterialImage}
                        />
                    }
                    />
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EducationMaterials));



/** WEBPACK FOOTER **
 ** ./src/containers/EducationMaterials/index.js
 **/